//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('dropdownMouseoutHide', [
    '$timeout',
    function(
            $timeout,
        ) {
      return {
        restrict: 'CA',
        link(scope, element, attributes) {
          const delay = parseInt(attributes.delay, 10) || 0;
          let timeoutPromise;

          element.on('mouseenter', () => {
            if (timeoutPromise) {
              $timeout.cancel(timeoutPromise);
            }
          }).on('mouseleave', () => {
            timeoutPromise = $timeout(() => {
                            // For some reason, toggling the "open" class on the .dropdown parent doesn't work as expected
                            // I think that the dropdown jQuery plugin is keeping state somewhere, as just removing the "open" class on the parent
                            // requires the user to click on the toggle twice to reopen the dropdown. Strange.
              if (element.hasClass('open')) {
                element.children('.dropdown-toggle').click();
              }

              timeoutPromise = null;
            }, delay);
          });
        },
      };
    },
  ]);
})();
